<template>
    <TopNav></TopNav>
    <h1>Калькулятор дисперсії</h1>
    <fieldset>
        <legend>Калькулятор дисперсії</legend>
        <label for="numbersField">Числа:</label>
        <textarea v-model="numbers" autofocus id="numbersField" rows="4">
        </textarea>
        <br>
        <input type="radio" id="sample" v-model="sampleOrPopulation" name="sample" value="sample"><label for="sample">вибірка</label><br>
        <input type="radio" id="population" v-model="sampleOrPopulation" name="population" value="population"><label for="population">сукупність</label><br>
        <br>
        Дисперсія: <span class="blue">{{ variance() }}</span>
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
    name: "VarianceCalculator",
    data() {
        return {
            numbers: "10, 10",
            sampleOrPopulation: "population"
        }
    },
    components: {
        TopNav
    },
    methods: {
        variance: function () {
            let numbersArray = this.numbers.match(/-?[0-9]+/g);
            if (!Array.isArray(numbersArray)) {
                return "";
            }
            numbersArray = numbersArray.map(Number);
            let sum = numbersArray.reduce((a, b) => a + b);
            let mean = sum / numbersArray.length;
            let summations = 0;
            numbersArray.forEach(element => {
                let distance = (element - mean);
                let squareOfDistance = Math.pow(distance, 2);
                summations += squareOfDistance;
            });
            let variance = 0;
            if (this.sampleOrPopulation === "sample") {
                variance = summations / (numbersArray.length - 1);
            } else {
                variance = summations / numbersArray.length;
            }
            return variance;
        },
    },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

label {
    display: inline-block;
    width: 110px;
}

textarea {
    vertical-align: top;
    width: 98%;
}

footer section a {
    margin: 20px;
}

.blue {
    color: blue;
}
</style>
